import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dynamic-windows]',
  standalone: true
})
export class DynamicWindows {
    constructor(public viewContainer: ViewContainerRef) {}
}
